import { ExpressionManager } from "../../expressions/ExpressionManager";
export class ExpressionController {
  constructor(param) {
    this.param = param;
  }
  dispose() {
    this.param.scene().expressionsController.deregisterParam(this.param);
    this._resetMethodDependencies();
  }
  _resetMethodDependencies() {
    var _a, _b;
    (_a = this._method_dependencies_by_graph_node_id) == null ? void 0 : _a.forEach((method_dependency) => {
      method_dependency.dispose();
    });
    (_b = this._method_dependencies_by_graph_node_id) == null ? void 0 : _b.clear();
  }
  registerMethodDependency(method_dependency) {
    this._method_dependencies_by_graph_node_id = this._method_dependencies_by_graph_node_id || /* @__PURE__ */ new Map();
    this._method_dependencies_by_graph_node_id.set(method_dependency.graphNodeId(), method_dependency);
  }
  active() {
    return this._expression != null;
  }
  expression() {
    return this._expression;
  }
  is_errored() {
    if (this._manager) {
      return this._manager.is_errored();
    }
    return false;
  }
  error_message() {
    if (this._manager) {
      return this._manager.error_message();
    }
    return null;
  }
  requires_entities() {
    return this.param.options.isExpressionForEntities();
  }
  set_expression(expression, set_dirty = true) {
    var _a;
    this.param.scene().missingExpressionReferencesController.deregisterParam(this.param);
    this.param.scene().expressionsController.deregisterParam(this.param);
    if (this._expression != expression) {
      this._resetMethodDependencies();
      this._expression = expression;
      if (this._expression) {
        this._manager = this._manager || new ExpressionManager(this.param);
        this._manager.parseExpression(this._expression);
      } else {
        (_a = this._manager) == null ? void 0 : _a.reset();
      }
      if (set_dirty) {
        this.param.setDirty();
      }
    }
  }
  updateFromMethodDependencyNameChange() {
    if (this._manager && this.active()) {
      this._manager.updateFromMethodDependencyNameChange();
    }
  }
  computeExpression() {
    if (this._manager && this.active()) {
      return this._manager.computeFunction();
    }
  }
  async computeExpressionForEntities(entities, callback) {
    var _a, _b;
    this._setEntities(entities, callback);
    await this.computeExpression();
    if ((_a = this._manager) == null ? void 0 : _a.error_message()) {
      this.param.node.states.error.set(`expression evalution error: ${(_b = this._manager) == null ? void 0 : _b.error_message()}`);
    }
    this._resetEntities();
  }
  computeExpressionForPoints(entities, callback) {
    return this.computeExpressionForEntities(entities, callback);
  }
  computeExpressionForObjects(entities, callback) {
    return this.computeExpressionForEntities(entities, callback);
  }
  entities() {
    return this._entities;
  }
  entityCallback() {
    return this._entityCallback;
  }
  _setEntities(entities, callback) {
    this._entities = entities;
    this._entityCallback = callback;
  }
  _resetEntities() {
    this._entities = void 0;
    this._entityCallback = void 0;
  }
}
